import { EntityDescriptor } from '../business-logic';
import { launchSchema } from '../schemas/launch';

export const launchEntity: EntityDescriptor = {
	launch: {
		schema: launchSchema,
		migrationStrategies: {
			1: function (oldDoc: any) {
				oldDoc.id = oldDoc.id ?? '';
				return oldDoc;
			},
		},
	},
};
